import styled from 'styled-components';
import { styles } from '../styles';

export const Heading = styled.h3`
  font-size: 14px;
  font-family: ${styles.defaultFontMedium};
  color: ${styles.textColor};
  margin: 0px;
`;
